<span *ngIf="sectionTitle" class="section-title flexItemBiggest">
    <div id="section-title" acLabel>{{sectionTitle}}{{postfixTitle}}</div>
</span>
<span class="section-content" [class.flexItemBiggest]="!sectionTitle" [class.flexItem]="sectionTitle">
    <ng-content></ng-content>
</span>
